import type { PortId } from '../model/NodeBase.js';

export const Warnings = '__internalPort_Warnings';
export const WarningsPort = Warnings as unknown as PortId;
